import React, { forwardRef } from 'react';
import { Box, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import PriceSummaryTables from './PriceSummaryTables';
import { formatDate } from '../../app/date';
import { createAppTheme } from '../../theme/appTheme';
import {
  resolveBudgetCaptureSubtitle,
  resolveBudgetCaptureTitle,
} from './priceSimulationBudgetExport';

const budgetExportTheme = createAppTheme('light');

const PriceSimulationBudgetCapture = forwardRef(function PriceSimulationBudgetCapture(
  { translate, result, payloadProduct, itemContext = null },
  ref,
) {
  if (!result || !payloadProduct) return null;

  const budgetDate = formatDate(new Date());
  const simulationDescription = String(payloadProduct.description || '').trim();
  const title = resolveBudgetCaptureTitle({
    productName: itemContext?.productName,
    skuCode: itemContext?.skuCode,
    skuAttributes: itemContext?.skuAttributes,
    itemDescription: itemContext?.itemDescription,
    simulationDescription,
  });
  const subtitle = resolveBudgetCaptureSubtitle({
    productName: itemContext?.productName,
    skuCode: itemContext?.skuCode,
    itemDescription: itemContext?.itemDescription,
    simulationDescription,
  });

  return (
    <Box
      ref={ref}
      sx={{
        position: 'fixed',
        left: -10000,
        top: 0,
        width: 720,
        bgcolor: '#ffffff',
        color: '#1a1a1a',
        p: 2.5,
        boxSizing: 'border-box',
        zIndex: -1,
        pointerEvents: 'none',
      }}
    >
      <Typography
        component="p"
        sx={{
          m: 0,
          mb: title ? 0.75 : 1.25,
          fontSize: '0.72rem',
          fontWeight: 500,
          letterSpacing: '0.02em',
          color: '#666',
          textTransform: 'none',
        }}
      >
        {translate('extensions.price_simulator.budget_png_title', { date: budgetDate })}
      </Typography>
      {title ? (
        <Typography
          component="p"
          sx={{
            m: 0,
            mb: subtitle ? 0.5 : 1.5,
            fontSize: '1.125rem',
            fontWeight: 700,
            lineHeight: 1.35,
            wordBreak: 'break-word',
            color: '#1a1a1a',
          }}
        >
          {title}
        </Typography>
      ) : null}
      {subtitle ? (
        <Typography
          component="p"
          sx={{
            m: 0,
            mb: 1.5,
            fontSize: '0.875rem',
            fontWeight: 500,
            lineHeight: 1.35,
            wordBreak: 'break-word',
            color: '#666',
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
      <ThemeProvider theme={budgetExportTheme}>
        <PriceSummaryTables translate={translate} result={result} payloadProduct={payloadProduct} />
      </ThemeProvider>
    </Box>
  );
});

export default PriceSimulationBudgetCapture;
